export enum RequiredUserAction {
	None,
	IsLoginWorking,
	AccountActivation,
	PasswordChange,
	BettingActivity,
	AcceptNewTerms,
	ConfirmUserData,
	AccActivationCongratulation,
	UserMatching,
	AcceptGdpr,
}
